import React from 'react';

const Wa = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 4.459c-3.57 0-6.472 2.902-6.477 6.472 0 1.223.344 2.416.992 3.443l.152.245-.653 2.387 2.45-.643.236.142c.992.59 2.131.904 3.295.904H11c3.565 0 6.546-2.903 6.546-6.473 0-1.728-.746-3.354-1.97-4.577A6.423 6.423 0 0 0 11 4.46zm3.806 9.252c-.162.456-.938.869-1.311.923-.62.093-1.1.044-2.333-.486-1.95-.845-3.226-2.81-3.325-2.937-.098-.127-.795-1.056-.795-2.013 0-.958.5-1.43.683-1.626a.709.709 0 0 1 .52-.245c.128 0 .26 0 .373.005.118.005.28-.045.437.334.162.388.55 1.345.6 1.443.049.099.083.212.014.34-.373.746-.77.716-.57 1.06.752 1.291 1.503 1.738 2.647 2.313.197.098.31.083.423-.05.113-.127.486-.569.614-.76.127-.197.26-.162.437-.099.176.064 1.134.536 1.33.634.197.098.325.147.374.226.044.093.044.486-.118.938zM19.643 0H2.357A2.358 2.358 0 0 0 0 2.357v17.286A2.358 2.358 0 0 0 2.357 22h17.286A2.358 2.358 0 0 0 22 19.643V2.357A2.358 2.358 0 0 0 19.643 0zm-8.648 18.72a7.78 7.78 0 0 1-3.722-.948l-4.13 1.085 1.105-4.037a7.76 7.76 0 0 1-1.041-3.894c.005-4.292 3.496-7.783 7.788-7.783 2.082 0 4.037.81 5.51 2.283 1.468 1.474 2.352 3.428 2.352 5.51 0 4.292-3.57 7.784-7.862 7.784z"
      fill="currentColor"
    />
  </svg>
);

export default Wa;
